import * as React from 'react';

type Props = {
  onClick: () => void;
  disabled: boolean;
  elRef: React.LegacyRef<HTMLButtonElement>;
};

const ConnectButton = (props: Props) => {
  return (
    <button
      onClick={props.onClick}
      ref={props.elRef}
      type="button"
      disabled={props.disabled}
      className="ichi-balance-button-bg-color max-w-[224px] h-10 px-3 py-2 rounded-[10px] text-white font-semibold text-base ml-3 hover:opacity-90"
    >
      Connect a wallet
    </button>
  );
};

export default ConnectButton;
